@if (show) {
    <div class="media card tips-card">
        <div class="tips-badge">
            {{'tip.title' | translate}}
        </div>
        <div class="card-top">
            <div class="tips-icon">
                <img src="/assets/images/tips-icon.png">
            </div>
            <div class="tips-content">
                <p class="tips-hook">{{tip.title}}</p>
                <p>{{tip.description}}</p>
                <div class="d-md-flex justify-content-center align-items-center pt-2">
                    <button class="btn tips-btn-learn"
                            (click)="showTip(tip)">{{'tip.more' | translate}}
                    </button>
                    <button class="tips-btn-skip mt-1"
                            (click)="dismiss(tip)">{{'tip.dismiss' | translate}}</button>
                </div>
            </div>
        </div>
    
    </div>
}


